import { useTranslation } from '@/locales';

import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';

export const SettingsHeader = () => {
  const { t } = useTranslation('common');
  const { isDesktop } = useBreakpointsCtx();

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledBasicToolbar>
        <StyledAgioH1
          noWrap
          color="customSecondary.primary.DEFAULT"
          data-testid="settings-header-title"
        >
          {t('settings.header.title')}
        </StyledAgioH1>
      </StyledBasicToolbar>
    </StyledHeader>
  );
};
